let settings = {};

function addScriptOnce(id, src) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function initTracking(cfg) {
  settings = cfg || {};
  if (window.__trackingLoaded) return;
  window.__trackingLoaded = true;

  if (settings.meta_pixel_id) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", settings.meta_pixel_id);
    window.fbq("track", "PageView");
  }

  if (settings.google_ads_id) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    addScriptOnce("gtag-js", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(settings.google_ads_id)}`);
    window.gtag("js", new Date());
    window.gtag("config", settings.google_ads_id);
  }
}

export function trackLead(source) {
  if (window.fbq) window.fbq("track", "Lead", { content_name: source });
  if (window.gtag && settings.google_ads_id && settings.google_ads_label) {
    window.gtag("event", "conversion", {
      send_to: `${settings.google_ads_id}/${settings.google_ads_label}`,
    });
  }
}
